import Tagify from '@yaireo/tagify'

const initTagify = () => {
    document.querySelectorAll('input.tagify').forEach((el) => {
      if (el.tagifyInstance) {
        return
      }

      const options = {}
      if (el.dataset.tagifyValidateEmail) {
        // eslint-disable-next-line require-unicode-regexp
        options.pattern = /^\S+@\S+\.\S+$/
      }

      el.tagifyInstance = new Tagify(el, options)
    })
  },
  destroyTagifyIn = (root) => {
    root.querySelectorAll('input.tagify').forEach((el) => {
      el.tagifyInstance?.destroy()
      el.tagifyInstance = null
    })
  }

document.addEventListener('turbo:load', initTagify)

// Tear down before Turbo caches the page snapshot so a Back/Forward restore
// doesn't double-render: `el.tagifyInstance` is a runtime property that doesn't
// survive caching, and Tagify's generated DOM would otherwise be re-wrapped on init.
document.addEventListener('turbo:before-cache', () => {
  destroyTagifyIn(document)
})
